export * from "../server/web/exports/index";

//# sourceMappingURL=server.js.map